import { render, staticRenderFns } from "./WeeklyProjectionManager.vue?vue&type=template&id=f4d8650a&scoped=true"
import script from "./WeeklyProjectionManager.vue?vue&type=script&lang=js"
export * from "./WeeklyProjectionManager.vue?vue&type=script&lang=js"
import style0 from "./WeeklyProjectionManager.vue?vue&type=style&index=0&id=f4d8650a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d8650a",
  null
  
)

export default component.exports